import React, { useMemo } from 'react';
import { useDENTContext } from '../../Services/DENTContext';
import { ViewOption } from '../../Interfaces/ViewOption.interface';
import DENTModalOverviewViewOption from './DENTModalOverviewViewOption';
// @ts-ignore
import styles from './DENTModalOverviewViewOptions.module.scss';

const DENTModalOverviewViewOptions = () => {
	const {
		showEndodontic,
		setShowEndodontic,
		showPeriodontal,
		setShowPeriodontal,
		showDental,
		setShowDental,
	} = useDENTContext();

	const options: ViewOption[] = useMemo(
		() => [
			{
				title:
					'patientTreatment.meddiDENT.dentalCross.overviewModal.showEndodontic',
				onClick: () => setShowEndodontic(!showEndodontic),
				isActive: showEndodontic,
			},
			{
				title:
					'patientTreatment.meddiDENT.dentalCross.overviewModal.showPeriodontal',
				onClick: () => setShowPeriodontal(!showPeriodontal),
				isActive: showPeriodontal,
			},
			{
				title:
					'patientTreatment.meddiDENT.dentalCross.overviewModal.showDental',
				onClick: () => setShowDental(!showDental),
				isActive: showDental,
			},
		],
		[showEndodontic, showPeriodontal, showDental],
	);

	return (
		<div className={styles.wrapper}>
			{options.map(option => (
				<DENTModalOverviewViewOption key={option.title} {...option} />
			))}
		</div>
	);
};

export default DENTModalOverviewViewOptions;
